<div class="onboardingform">
  <div class="subscription-wrapper">
    <h1 class="mt-lg-1">Choose your plan</h1>
    <app-subscription-packages (packageChange)="handleSelection($event)"></app-subscription-packages>
  </div>
</div>

<app-profile-dropdown [signUpFlow]="true"></app-profile-dropdown>
